
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CivilButton from '../../ReusableComponent/CIVIL/CivilButton/CivilButton';


function BookLessonPage() {
    const location = useLocation();
    const lessonData = location?.state?.lessonData || {};
    const bookData = location?.state?.bookData || {};



    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);



    let componentName = 'bookLessonPage';
    console.log(lessonData, "lessonData in BookLessonPage");


    // if (lessonData.ShowClassQuestions == 1 && lessonData.ShowPrelims == 1) {
    //     componentName = "CourseDescriptionprelimstest"
    // } else {
    //     if (lessonData.ShowClassQuestions == 1) {
    //         componentName = "CourseDescription"
    //     } else if (lessonData.ShowPrelims == 1) {
    //         if (lessonData.QuestionCount === 0 || lessonData.QuestionCount === null || lessonData.QuestionCount === undefined) {
    //             componentName = "WithoutPrelimsDescription"
    //         } else {
    //             componentName = "PrelimsDescription"
    //         }
    //     } else {
    //         componentName = "WithoutPrelimsDescription"
    //     }
    // }
    return (
        <>
            <div className='Dashboard-background'>
                <div className='container-fluid'>
                    <div className='row'  >
                        <div className='col-lg-3 col-md-12 col-sm-12 dashboardmain-left p-3'>
                            <div className='Descriptionleft-background'>
                                <div className='card DescriptionCard'>
                                    <div className="d-grid mb-3">
                                        <button className="btn btn-darkgreen" type="submit">{lessonData?.Title}</button>
                                    </div>
                                    <div className='descriptionbottom ' style={{ height: "10rem" }}>
                                        <div>
                                            {/* <p className='fw-bold'>Classes are accessible only through INSIGHT App</p> */}
                                        </div>
                                        <div>{/* <HiPlay className='fs-4 text-danger' /> */}</div>
                                    </div>
                                </div>
                            </div>
                            {/* <CourseDescriptionleft courseDescriptionData={lessonData?.Title} /> */}
                        </div>
                        <div className='col-lg-9 col-md-12 col-sm-12' >
                            <CivilButton bookData={bookData} lessonData={lessonData} componentName={componentName} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BookLessonPage
